const DojoWebPosResult = Object.freeze({
    SUCCESS: 'success',
    FAILURE: 'failure',
});

module.exports = DojoWebPosResult;
